import type { OrgRegistrationFilters, OrgRegistrationTab } from '../types'

/** The tabs, in display order. */
export const ORG_REGISTRATION_TABS: readonly OrgRegistrationTab[] = [
  'open',
  'upcoming',
  'all',
]

/** The tab a bare URL opens on. Omitted from the URL when selected. */
export const DEFAULT_ORG_REGISTRATION_TAB: OrgRegistrationTab = 'open'

/** Registrations per page as the list scrolls. */
export const ORG_REGISTRATIONS_PER_PAGE = 10

/** An open registration closing within this many days reads as "Closing soon". */
export const CLOSING_SOON_DAYS = 14

/** A capped division at or below this share of its spots reads as low. */
export const LOW_SPOTS_RATIO = 0.25

/**
 * URL query keys for the filters, so the list can be shared as a link. Short
 * and readable — these are user-visible.
 */
export const ORG_REGISTRATION_FILTER_PARAM_KEYS: Record<
  keyof OrgRegistrationFilters,
  string
> = {
  status: 'status',
  search: 'q',
  sportId: 'sport',
  genericSportId: 'generic_sport',
  venueId: 'venue',
  showChildOrganizations: 'child_orgs',
}

export const EMPTY_ORG_REGISTRATION_FILTERS: OrgRegistrationFilters = {
  status: DEFAULT_ORG_REGISTRATION_TAB,
  search: '',
  sportId: '',
  genericSportId: '',
  venueId: '',
  showChildOrganizations: false,
}

/** Shown when a registration's competition has no logo of its own. */
export const ORG_REGISTRATION_COMPETITION_PLACEHOLDER =
  '/images/generic_placeholders/placeholder_competition.png'

/** Shown when a registration's organization has no logo of its own. */
export const ORG_REGISTRATION_ORGANIZATION_PLACEHOLDER =
  '/images/generic_placeholders/placeholder_organization.png'
